import { IRecommendedPackageService } from '../../../../types/reducers/recommendedPackages';
import { ECustomPackageServiceType, TCustomPackageService } from '../../../../../PayPackageMicrofrontend';
import { getIcon } from './getIcon';
import { getServiceName } from './getServiceName';
import { mapPublicServiceType } from '../../../../utils/publishTerms';
import { lowerFirst } from '../../../../utils/string';

export const mapCustomService = (service: IRecommendedPackageService): TCustomPackageService => {
  const { auctionPoints, count, serviceType, price, durationInDays } = service;

  const type = mapPublicServiceType(serviceType)!;

  return {
    auctionPoints,
    count,
    icon: getIcon(serviceType),
    price,
    name: getServiceName(serviceType),
    durationInDays,
    serviceType: lowerFirst(type) as ECustomPackageServiceType,
  };
};
